var datePickerController = function ($scope, $element, $attrs) {

    var self = this;
    $scope.navDate = null;

    this.makeHeader = function () {
        $scope.weekDaysHeader = [];
        var weekDaysArr = [0, 1, 2, 3, 4, 5, 6];
        weekDaysArr.forEach(function (day) {
            $scope.weekDaysHeader.push(moment().weekday(day).format('ddd'))
        });
    };

    this.makeGrid = function () {
        $scope.grid = [];

        var currentDate = moment();
        var firstDayDate = moment($scope.navDate).startOf('month');
        var initialEmptyCells = firstDayDate.weekday();
        var lastDayDate = moment($scope.navDate).endOf('month');
        var lastEmptyCells = 6 - lastDayDate.weekday();
        var daysInMonth = $scope.navDate.daysInMonth();
        var len = initialEmptyCells + lastEmptyCells + daysInMonth;

        for (var i = 0; i < len; i++) {
            var obj = {};
            if (i < initialEmptyCells || i > initialEmptyCells + daysInMonth - 1) {
                obj.value = 0;
                obj.available = false;
            } else {
                var dayNum = i - initialEmptyCells + 1;
                obj.value = dayNum;
                obj.available = this.isAvailable(dayNum);
                obj.date = this.dateFromNum(dayNum, $scope.navDate);
                obj.current = currentDate.isSame(obj.date, 'day');
            }
            $scope.grid.push(obj);
        }
    };

    this.isAvailable = function (num) {
        if ($scope.isAvailableLogic) {
            var dateToCheck = this.dateFromNum(num, $scope.navDate);
            return $scope.isAvailableLogic({value: dateToCheck});
        } else {
            return true;
        }
    };

    $scope.canChangeNavMonth = function (num) {
        if ($scope.canChangeNavMonthLogic) {
            return $scope.canChangeNavMonthLogic({value: moment($scope.navDate).add(num, 'months')});
        } else {
            return true;
        }
    };

    this.dateFromNum = function (num, referenceDate) {
        var returnDate = moment(referenceDate);
        return returnDate.date(num);
    };

    $scope.selectDay = function (day) {
        if (day.available) {
            $scope.selectedDate = self.dateFromNum(day.value, $scope.navDate);
            if ($scope.onDateSelected) $scope.onDateSelected({value: $scope.selectedDate});
        }
    };

    $scope.changeNavMonth = function (num) {
        if ($scope.canChangeNavMonth(num)) {
            $scope.navDate.add(num, 'month');
            $scope.navDateLabel = $scope.navDate.format('MMMM YYYY');
            self.makeGrid();
        }
    };

    this.init = function () {
        $scope.navDate = moment();
        $scope.navDateLabel = $scope.navDate.format('MMMM YYYY');
        this.makeHeader();
        this.makeGrid();
    };

    $scope.$watch('selectedDate', function (newValue, oldValue) {
        $scope.selectedDate = moment(newValue);
    }, true);
};

var datePickerLink = function ($scope, $element, $attrs, ctrl) {
    ctrl.init();
};

//mileage scroll item function injections
datePickerController.$inject = ['$scope', '$element', '$attrs', '$rootScope'];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            selectedDate: "=",
            canChangeNavMonthLogic: "&",
            isAvailableLogic: "&",
            onDateSelected: "&"
        },
        // replace: true,
        controller: datePickerController,
        link: datePickerLink,
        templateUrl: 'template/directives/date-picker'
    }
};
